import { DesignationActionDTO } from "./designation-action.dto";
import { Injectable } from "@nestjs/common";
import { DesignationAction } from "../designation-action.entity";

@Injectable()
export class DesignationActionAdapter{

    public convertDtoToEntity(dto: DesignationActionDTO, isUpdate: boolean = false): DesignationAction{
        const entity = new DesignationAction();
        entity.designationActionId = dto.designationActionId;
        entity.designationDate =dto.designationDate;
        entity.employeeCode= dto.employeeCode;
        entity.employeeName = dto.employeeName;
        entity.employeeId = dto.employeeId;
        entity.fromDesignation=dto.fromDesignation;
        entity.toDesignation=dto.toDesignation;
        entity.department = dto.department;
        entity.toDepartment = dto.toDepartment;
        entity.approvedBy=dto.approvedBy;
        entity.updatedUser=dto.updatedUser;
        entity.updatedAt=dto.updatedAt;
        entity.createdUser=dto.createdUser;
        // entity.fromDepartmentId=dto.fromDepartmentId;
        // entity.toDepartmentId=dto.toDepartmentId;
        entity.isActive = dto.isActive === undefined ? true : dto.isActive;
        if(isUpdate){

            entity.isActive = true;
             }
        return entity;
    }

    public convertEntityToDto(entity: DesignationAction): DesignationActionDTO{
        const dto = new DesignationActionDTO;
        dto.designationActionId = entity.designationActionId;
        dto.designationDate = entity.designationDate;
        dto.employeeCode = entity.employeeCode;
        dto.employeeName = entity.employeeName;
        dto.department = entity.department;
        dto.toDepartment = entity.toDepartment;
        dto.isActive = entity.isActive;
        dto.fromDesignation = entity.fromDesignation;
        dto.toDesignation = entity.toDesignation;
        dto.approvedBy = entity.approvedBy;
        dto.isActive = entity.isActive;
        dto.createdAt = entity.createdAt;
        dto.createdUser = entity.createdUser;
        dto.updatedAt = entity.updatedAt;
        dto.updatedUser = entity.updatedUser;
        dto.versionFlag = entity.versionFlag;
    //   dto.fromDepartmentId=entity.fromDepartmentId;
    //   dto.toDepartmentId=entity.toDepartmentId;
        return dto;

    }
}